import React from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Head from './Head';

import { IS_LOCAL } from '../../../../../utils/config';

const Active = ({ access, items, title, type, onEdit }) => (
  <div className="settings-integrations__block">
    <div className="settings-integrations__block-title">{title}</div>
    <div className="settings-integrations__block-body">
      <table>
        <Head />
        <tbody>
          {items?.map((item) => {
            const checkTypeBtn = access?.integrations_edit && type === 'disabled'
              ? 'Activate'
              : access?.integrations_edit && type === 'edit'
                ? 'Edit'
                : null;
            return (
              <tr key={item.id} className="settings-integrations__block-body--row">
                <td className="settings-integrations__block-body--row-img">
                  {item.icon && <img src={IS_LOCAL ? `https://panel.perfectpanel.dev${item.icon}` : item.icon} alt={item.title} />}
                </td>
                <td className="settings-integrations__block-body--row-name">
                  <div
                    className={classNames('', {
                      disabled: type === 'disabled',
                    })}
                  >
                    {item.title}
                  </div>
                  <div className="settings-integrations__block-body--row-desc">{item.description}</div>
                </td>
                {checkTypeBtn ? (
                  <td className="settings-integrations__block-body--row-actions">
                    <Button bsSize="xsmall" onClick={() => onEdit(checkTypeBtn?.toLowerCase(), item)}>
                      {checkTypeBtn}
                    </Button>
                  </td>
                ) : null}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);

Active.propTypes = {
  access: PropTypes.object,
  items: PropTypes.array,
  title: PropTypes.string,
  type: PropTypes.string,
  onEdit: PropTypes.func,
};

export default Active;
